// Text-display helpers. Cosmetic only — never mutate the raw values used for
// lookups, search or payloads; format at the render boundary.

// Spanish connectors kept lowercase mid-string. Includes "con", the pivot of a
// carátula ("Demandante con Demandado"), on top of the article/preposition set.
const CONNECTORS = new Set([
  'de',
  'del',
  'la',
  'las',
  'los',
  'y',
  'e',
  'da',
  'con',
]);

// PJUD data (carátulas, names, tribunales) arrives in ALL CAPS with no
// consistent casing. Title-case it for display, keeping Spanish connectors
// lowercase and dotted acronyms (C.A., S.A., Ltda.) intact.
export function titleCase(value) {
  if (!value) return '';
  return String(value)
    .trim()
    .split(/\s+/)
    .map((w, i) => {
      // Keep dotted acronyms as-is — lowercasing "S.A." would yield "S.a.".
      if (w.includes('.') && /[A-ZÁÉÍÓÚÑ]/.test(w)) return w;
      const lower = w.toLowerCase();
      if (i > 0 && CONNECTORS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}
